import axios from 'axios'

export default {
  namespaced: true,

  state: {
    adspotList: [],
    pageAdspotList: [],
    total: 0,
    current: 1,
    editId: undefined,
    editAdspot: null
  },

  mutations: {
    add (state) {
      if (!state.pageAdspotList[0] || state.pageAdspotList[0].id) {
        state.editId = undefined
        state.editAdspot = { status: 1 }
        state.pageAdspotList.unshift({})
      }
    },

    cancelAdd (state) {
      state.editAdspot = null
      state.pageAdspotList.shift()
    },

    edit (state, { adspot }) {
      state.editId = adspot.id
      let newAdspot = { ...adspot }
      delete newAdspot._index
      delete newAdspot._rowKey
      state.editAdspot = newAdspot
      if (!state.pageAdspotList[0].id) {
        state.pageAdspotList.shift()
      }
    },

    cancelEdit (state) {
      state.editId = undefined
      state.editAdspot = null
    },

    replace (state, { adspot }) {
      const index = state.pageAdspotList.findIndex(item => !item.id || item.id === adspot.id)
      state.pageAdspotList.splice(index, 1, adspot)
    },

    setAll (state, { adspotList }) {
      state.adspotList = adspotList
    },

    setList (state, { adspotList, total, current }) {
      state.pageAdspotList = adspotList
      state.total = total
      state.current = current
    },

    remove (state, { id }) {
      const index = state.pageAdspotList.findIndex(item => item.id === id)
      state.pageAdspotList.splice(index, 1)
    }
  },

  actions: {
    getAll ({ commit }) {
      return axios.get('/adspot').then(({ data }) => {
        commit('setAll', {
          adspotList: [...data]
        })
      })
    },

    getList ({ commit }, params) {
      return axios.get('/adspot', {
        params: {
          page: params.current,
          search: params.searchText
        }
      }).then(({ data: { data, currentPage, count } }) => {
        commit('setList', {
          adspotList: [...data],
          total: count,
          current: currentPage
        })
      })
    },

    submitAdd ({ state, commit, dispatch }) {
      axios.post(`/adspot`, { adspot: state.editAdspot }).then(result => {
        if (result !== -1) {
          commit('replace', { adspot: result.data })
          this._vm.$Message.success('添加广告位成功')
          commit('cancelEdit')
          dispatch('getList', { current: 1 })
        }
      })
    },

    submitEdit ({ state, commit, dispatch }) {
      axios.put(`/adspot/${state.editAdspot.id}`, { adspot: state.editAdspot }).then(result => {
        if (result !== -1) {
          commit('replace', { adspot: result.data })
          this._vm.$Message.success('更新广告位成功')
          commit('cancelEdit')
          dispatch('getList', { current: state.current })
        }
      })
    },

    delete ({ state, commit, dispatch }, { adspot }) {
      axios.delete(`/adspot/${adspot.id}`).then(result => {
        commit('remove', { id: adspot.id })
        this._vm.$Message.success(result.data)
        commit('cancelEdit')
        dispatch('getList', { current: state.current })
      })
    }
  }
}
